export default __webpack_public_path__ + "static/media/logo.e37a6ec8.png";